const jquery = window.jquery;
const adw = window.adw;

/**
 * Load Taxonomy data
 *
 * @param taxonomy
 * @param term
 * @param currentPage
 * @returns {*}
 */
export default function getTaxPostsByTermID( taxonomy, term, currentPage ) {

    const options = {

        type: 'POST',
        url: adw.ajaxurl,
        dataType: "json",
        data: {
            action : 'tax_ajax_query',
            current_page : currentPage,
            taxonomy: taxonomy,
            taxonomy_term : term,
            offset: 10,
            posts_per_page : 10
        }

    };
    // console.log(options);

    return new Promise( function ( resolve, reject ) {

        jquery.ajax( options ).done( resolve ).fail( reject );

    });

};
